<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title" v-if="getModalData.id">Edit Active Ingredient</div>
      <div class="title" v-else>Add Active Ingredient</div>
    </div>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form__bent">
        <label class="form__label">Name</label>
        <div class="form__inlet">
          <input type="text" class="form__field" v-model="form.name"/>
        </div>
      </div>
      <div class="form__bent">
        <label class="form__label">Pesticides</label>
        <div class="form__inlet">
          <vue-select v-model="form.pesticides_id" :options="getPesticidesOptionsList" :settings="{multiple: true}"/>
        </div>
      </div>
      <div class="form__btn">
        <button class="btn" type="submit" v-if="getModalData.id">Save</button>
        <button class="btn" type="submit" v-else>Add</button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'ModalActiveIngredient',
    computed: {
      ...mapGetters([
        'getPesticidesOptions',
        'getModalData',
      ]),
      getPesticidesOptionsList() {
        let items = this.getPesticidesOptions();
        return _.map(items, p => {
          return {
            id: p.id,
            text: p.text['en']
          }
        })
      }
    },
    data() {
      return {
        form: {
          name: '',
          pesticides_id: [],
        }
      }
    },
    mounted() {
      if (this.getModalData.id) {
        this.form = {
          name: this.getModalData.name,
          pesticides_id: this.getModalData.pesticides_id,
        }
      }
    },
    methods: {
      ...mapActions([
        'storeActiveIngredient',
        'updateActiveIngredient',
      ]),
      onSubmit() {
        if (this.getModalData.id)
          this.updateActiveIngredient([this.getModalData.id, this.form])
        else
          this.storeActiveIngredient(this.form)
      }
    }
  }
</script>

<style scoped>
  .popup { padding: 50px 100px !important }
  .form__inlet { display: block }
</style>